import {
  SET_PLAYER_SETTINGS,
  CLEAR_PLAYER_SETTINGS,
  SET_CHAPTER_LIST,
} from '../actions/player';

const INITIAL_STATE = {
  settings: {},
  chapter_list: {},
};

const Player = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_PLAYER_SETTINGS:
      return {
        ...state,
        settings: action.value,
      };
    case CLEAR_PLAYER_SETTINGS:
      return {
        ...state,
        settings: {},
      };
    case SET_CHAPTER_LIST:
      return {
        ...state,
        chapter_list: action.value,
      };
    default:
      return state;
  }
};

export default Player;
